import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { CreditCardIcon } from "lucide-react";
import ActivityContentWrapper from "./activity-content-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import ActivityWrapper from "./activity-wrapper";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@babackapp/ui/components/accordion";
import useFormatPrice from "@/hooks/use-format-price.ts";
import useStripePaymentUrl from "./use-stripe-payment-url";
import { useCurrentReturnRequest } from "@/pages/(app)/returns/utils/current-return-request-context";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@babackapp/ui/components/dialog";
import StripeRefundForm from "@/components/stripe-refund/stripe-refund-form";
import { useState } from "react";

type TransactionCapturedActivityProps = {
  activity: ReturnRequestLogDto;
};

type TransactionCapturedActivityValues = {
  accountId: string;
  amount: string;
  currency: string;
  lang: string;
  last4: string;
  origin: string;
  transactionId: string;
}

export default function TransactionCapturedActivity({
  activity,
}: TransactionCapturedActivityProps) {
  const t = useTranslation();
  const formatPrice = useFormatPrice()
  const transaction = activity.params as unknown as TransactionCapturedActivityValues;
  const [refundModalOpen, setRefundModalOpen] = useState(false);

  const externalLink = useStripePaymentUrl(transaction.accountId, transaction.transactionId);
  const returnRequest = useCurrentReturnRequest();

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <CreditCardIcon className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2">
          <Accordion type="single" collapsible>
            <AccordionItem value="item-1" className="border-0">
              <AccordionTrigger className="p-0">
                <ActivityItemHeader
                  title={t("returnDetail.transaction.capturedTitle", {
                    amount: formatPrice({
                      amount: parseFloat(transaction.amount),
                      currency: transaction.currency
                    })
                  })}
                  timestamp={activity.date}
                >
                </ActivityItemHeader>
              </AccordionTrigger>
              <AccordionContent>
                <div className="text-xs">
                  <div className="mt-1">{t("returnDetail.transaction.cardNumber")}: **** ****
                    **** {transaction.last4 || '****'}</div>
                  <div className="mt-1 mb-1">{t("returnDetail.transaction.cardHolder")}: {transaction.origin}</div>
                  <div className="flex gap-2">

                  {externalLink && (
                    <a
                      className="text-blue-500"
                      href={externalLink}
                      target="_blank" rel="noreferrer"
                    >
                      {t("returnDetail.transaction.externalLink")}
                    </a>
                  )}
                  {returnRequest.financial_informations?.intentId && (
                    <Dialog open={refundModalOpen} onOpenChange={setRefundModalOpen}>
                      <DialogTrigger asChild>
                        <span className="text-xs text-blue-500 cursor-pointer">
                          {t("returnDetail.transaction.refund")}
                        </span>
                      </DialogTrigger>
                      <DialogContent aria-describedby={undefined}>
                        <DialogHeader>
                          <DialogTitle>{t("returnDetail.transaction.refund")}</DialogTitle>
                        </DialogHeader>
                        <StripeRefundForm intentId={returnRequest.financial_informations.intentId} onSubmit={() => setRefundModalOpen(false)}/>
                      </DialogContent>
                    </Dialog>
                  )}
                  </div>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
